import { createStore } from "vuex";
const { supermemo } = require("supermemo");
import { supabase } from "../supabase";
import router from "../router";
import { v4 as uuidv4 } from "uuid";

import ErrorToast from './errortoast.js'
import * as sb from './supabasecalls.js'

import * as pickCards from './pickcards.js'

import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export default createStore({
  state: {
    collections: [],
    currentPackId: null,
    editCards: [],
    currentEditCardId: null,
    currentQueueCard: null,
    followingQueueCard: null,
    showBack: false,
    scores: [],
    error: "",
    tourProgression: 0,
    crammingMode: false,
    lastNewBatchCreated: 0,
    statistics: {},
    user: null,
    isPasswordReset: false,
    tags: [],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setProfile(state, profile) {
      state.profile = profile;
    },
    setStatistics(state, statistics) {
      state.statistics = statistics;
    },
    setCrammingMode(state, crammingMode) {
      state.crammingMode = crammingMode;
    },
    setTourProgression(state, progression) {
      state.tourProgression = progression;
    },
    setError(state, error) {
      state.error = error;
    },
    setCollections(state, collections) {
      state.collections = collections;
    },
    setPublicCollections(state, collections) {
      state.publicCollections = collections;
    },
    addCollection(state, collection) {
      state.collections.push(collection);
      state.editCards = [];
    },
    updateCollection(state, collection) {
      state.collections.splice(
        state.collections.indexOf(collection),
        1,
        collection
      );
    },
    deleteCollection(state, collection) {

      state.collections = state.collections.splice(
        state.collections.indexOf(collection),
        1
      );
    },
    setCurrentPackId(state, id) {

      state.currentPackId = id;
    },
    setEditCards(state, cards) {
      state.editCards = cards;
    },
    setCurrentQueueCard(state, card) {
      state.currentQueueCard = card;
    },
    setFollowingQueueCard(state, card) {
      state.followingQueueCard = card;
    },
    addCard(state, card) {
      // get current collection
      let currentCollection = state.collections.find(
        (collection) => collection.id === state.currentPackId
      );
      // add card to collection
      state.editCards.push(card);
    },
    deleteCard(state, deleteCard) {
      // remove card from collection
      state.editCards = state.editCards.filter(
        (card) => card.id !== deleteCard.id
      );
      // if the currentQueueCardis the one we are removing, set it to null
      if (
        state.currentQueueCard &&
        state.currentQueueCard.id === deleteCard.id
      ) {
        state.currentQueueCard = null;
      }
    },
    updateCard(state, note) {
      let editIndex = state.editCards.findIndex((card) => card.id === note.id);

      state.editCards[editIndex] = editIndex !== -1 ? { ...note } : null;

      // if the id of the current learn card is similar to the id of the card to update, update it
      if (state.currentQueueCard && state.currentQueueCard.id === note.id) {
        state.currentQueueCard = { ...note };
      }
    },
    setCardType(state, payload) {
      // find the relevant card by its id
      let currentCollection = state.collections.find(
        (collection) => collection.id === state.currentPackId
      );
      let cardToUpdate = state.editCards.find((card) => card.id === payload.id);
      // update the card
      state.editCards[state.editCards.indexOf(cardToUpdate)].type =
        payload.type;
    },

    setCurrentEditCardId(state, id) {
      state.currentEditCardId = id;
    },
    setShowBack(state, showBack) {
      state.showBack = showBack;
    },

    // SCORE
    setScore(state, score) {
      state.profile.score = score;
    },
    setScores(state, scores) {
      state.scores = scores;
    },
    addToScores(state, score) {
      state.scores.push(score);
      state.profile.score += score.value;
    },
    setTags(state, tags) {
      state.tags = tags;
    },
    addTag(state, tag) {
      state.tags.push(tag);
    }
  },
  actions: {
    async loadTags({ commit }) {
      const { data, error } = await supabase.from("tags").select("*");
      if (error) {
        console.log(error);
      } else {
        commit("setTags", data);
      }
    },
    async addTag({ commit }, newTag) {
      console.log('Store: adding tag', newTag);
      // check if tag already exists
      const tagExists = this.state.tags.find(tag => tag.name === newTag.name)
      if (!tagExists) {
        const { data, error } = await supabase.from("tags").insert([newTag]);
        if (error) {
          console.log(error);
        } else {
          commit("addTag", newTag);
          console.log('Store: added tag', data);
        }
      }

    },
    async addTagToCard({ commit }, connection) {
      const { data, error } = await supabase.from("tags_cards").insert([connection]);
      if (error) {
        console.log(error);
      } else {
        console.log('added tag to card', data);
      }
    },
    // properly jumping to card
    setCurrentPackId({ commit }, id) {
      commit("setCurrentPackId", id);
    },
    setCurrentEditCardId({ commit }, id) {
      commit("setCurrentEditCardId", id);
    },

    // SUPABASE STUFFf
    async signInAction({ commit }, form) {

      const { user, session, error } = await supabase.auth.signIn({
        email: form.email,
        password: form.password,
      })

      if (session) {
        commit("setCollections", []);
        commit("setEditCards", []);
        commit("setCurrentPackId", null);
        commit("setCurrentEditCardId", null);
        commit("setShowBack", false);
        commit("setScores", []);
        await router.push("/dashboard");
      }
    },

    async signOutAction() {
      const { error } = await supabase.auth.signOut()
      if (!error) await router.push("/login");
    },

    // SUPABASE COLLECTIONS
    // Collections are called packs in supabase because of double naming :(
    async getCollections({ commit, state }) {
      const data = await sb.getCollections();

      if (data) {

        commit("setCollections", data)
      }
    },

    async getPublicCollections({ commit, state }) {
      const data = await sb.getPublicCollections();
      commit("setPublicCollections", data)
    },

    async addCollection({ commit, state }, collection) {
      await sb.addCollection(collection);
      commit("addCollection", collection);

    },

    async deleteCollection({ commit, state }, collection) {
      // delete all cards in collection
      const deleteSuccessful = await sb.deleteCollection(collection);
      if (deleteSuccessful) {
        commit("setCurrentPackId", null);
      }
    },

    async cloneCollection({ commit, state }, collection) {
      // adding the actual collection
      const pack_id = uuidv4();
      const clonedCollection = {
        name: collection.name,
        description: collection.description,
        user_id: supabase.auth.currentUser.id,
        public: false,
        categories: collection.categories,
        id: pack_id,
        isDisabled: false,
        emoji: collection.emoji,
      };
      try {
        const { data, error } = await supabase
          .from("packs")
          .insert(clonedCollection);

        if (error) throw error;

      } catch (error) {
        ErrorToast('Could not clone collection. Try again', error)

      }


      // getting the cards of the collection to be cloned and add them to the created one
      try {
        const { error, data } = await supabase
          .from("cards")
          .select()
          .match({ pack_id: collection.id });
        if (error) throw error;

        let clonedCards = [];
        for (let card of data) {
          const clonedCard = {
            user_id: supabase.auth.currentUser.id,
            id: uuidv4(),
            type: card.type,
            front: card.front,
            back: card.back,
            nextShown: new Date() / 1000,
            ease: 0,
            interval: 1,
            repetition: 0,
            unit: card.unit,
            pack_id: pack_id,
            occurrences: 0,
          };

          // 
          // await supabase.from("cards").insert([clonedCard]);
          commit("addCard", clonedCard);
          clonedCards.push(clonedCard);
        }
        try {
          const { error } = await supabase.from("cards").insert(clonedCards, {
            returning: "minimal",
          });
          if (error) throw error;
          commit("addCollection", clonedCollection);
        } catch (error) {
          ErrorToast('Could not clone collection. Try again', error)

        }
      } catch (error) {
        ErrorToast('Could not clone collection. Try again', error)

      }
    },

    async updateCollection({ commit, state }, collection) {
      try {
        commit("updateCollection", collection);
        const { error } = await supabase
          .from("packs")
          .update(
            [
              {
                name: collection.name,
                description: collection.description,
                user_id: supabase.auth.currentUser.id,
                public: collection.public,
                isDisabled: collection.isDisabled,
                emoji: collection.emoji,
                categories: collection.categories,
              },
            ],
            { returning: "minimal" }
          )
          .match({ id: collection.id });
        if (error) throw error;
      } catch (error) {
        ErrorToast('Could not update collection. Try again', error)

      }
    },

    async getCards({ commit, state }) {
      commit("setEditCards", []);
      try {
        const { error, data } = await supabase
          .from("cards")
          .select()
          .match({ pack_id: state.currentPackId });
        if (error) throw error;
        commit("setEditCards", data);
      } catch (error) {
        ErrorToast('Could not get cards. Try again', error)
      }
    },

    async addCard({ commit, state }, card) {
      try {
        commit("addCard", card);
        const { data, error } = await supabase
          .from("cards")
          .insert([card], { returning: "minimal" });
        if (error) throw error;
        commit("setCurrentEditCardId", card.id);
      } catch (error) {
        ErrorToast('Could not add card. Try again', error)
      }
    },

    async deleteCard({ commit, state }, card) {
      try {
        commit("deleteCard", card);
        const { error } = await supabase
          .from("cards")
          .delete()
          .match({ id: card.id });
        if (error) throw error;
      } catch (error) {
        ErrorToast('Could not delete card. Try again', error)
      }
    },

    async updateCard({ commit, state }, card) {

      try {
        const { error } = await supabase
          .from("cards")
          .update(
            {
              user_id: supabase.auth.currentUser.id,
              id: card.id,
              type: card.type,
              front: card.front,
              back: card.back,
              nextShown: card.nextShown,
              ease: card.ease,
              interval: card.interval,
              repetition: card.repetition,
              unit: card.unit,
              pack_id: card.pack_id,
              occurrences: card.occurrences,
              priority: card.priority,
              startedReading: card.startedReading,
            },

            { returning: "minimal" }
          )
          .match({ id: card.id });
        if (error) throw error;
        commit("updateCard", card);
      } catch (error) {
        ErrorToast('Could not update card. Try again', error)
      }
    },

    async getEnabledCollections({ commit, state }) {
      try {
        const { error, data } = await supabase
          .from("packs")
          .select()
          .match({ user_id: supabase.auth.currentUser.id, isDisabled: false });
        if (error) throw error;
        return data;
      } catch (error) {
        ErrorToast('Could not get collections. Try again', error)
      }
    },


    async pickCard({ commit, state }, cardToPick) {

      if (cardToPick.which === 'following') {

        commit("setFollowingQueueCard", null)
      }

      const card = await pickCards.pickCard(state, cardToPick);



      // this only gets triggered when queue is newly opened and we freshly need a first card
      if (cardToPick.which === "current") {
        if (card) {

          commit("setCurrentQueueCard", card);
        } else {

          commit("setCurrentQueueCard", null);
        }
        if (cardToPick.which === "following") {
          if (card) {

            commit("setFollowingQueueCard", card);
          } else {

            commit("setFollowingQueueCard", null);
          }
        }
      }
    },

    async setNextShownOfCard({ commit, dispatch, state }, votingData) {
      try {
        const vote = votingData.vote;
        const score = votingData.score;
        const skipNote = votingData.skipNote;
        dispatch("addToScores", { vote, score, skipNote });

        let wasDeleted = false;

        // helper function that checks if the card is voted "Blackout" multiple times in a row
        async function checkIsLeech(card, vote) {
          // get all score objects belonging to this card from backend
          const { error, data } = await supabase
            .from("scores")
            .select()
            .order("datetime", { ascending: false })
            .eq("card_id", card.id)
            .match({ user_id: supabase.auth.currentUser.id });
          if (error) throw error;
          console.warn("found scores for leech check", data.length, data);
          // count how many times in a row the value of score was 0 or -1, going backwards from the newest score
          let leechCount = 1;
          for (let i = data.length - 1; i >= 0; i--) {
            if (
              data[i].value === 0 ||
              data[i].value === -1 ||
              data[i].input_type === 1
            ) {
              leechCount++;
            } else {
              break;
            }
          }
          // if the leech count is 6 or more  and divisible by 2, notify the user
          if (leechCount >= 6 && leechCount % 2 === 0) {
            if (card.type === "learning") {
              Toastify({
                text: `You got the previous card wrong ${leechCount} times in a row - it might be a leech. \n It's recommended that you ad a mnemonic to the card or add a hint.`,
                duration: 19000,
                newWindow: true,
                close: true,
                gravity: "bottom", // `top` or `bottom`
                position: "center", // `left`, `center` or `right`
                stopOnFocus: true, // Prevents dismissing of toast on hover
                style: {
                  background: "var(--primary-500)",
                },
              }).showToast();
            } else if (card.type === "habit") {
              Toastify({
                text: `You delayed the previous card ${leechCount} times in a row - it might be a leech. \n Do you have everything ready to do the task? Is the scope of the task appropriate?`,
                duration: 19000,
                newWindow: true,
                close: true,
                gravity: "bottom", // `top` or `bottom`
                position: "center", // `left`, `center` or `right`
                stopOnFocus: true, // Prevents dismissing of toast on hover
                style: {
                  background: "var(--primary-500)",
                },
              }).showToast();
            } else if (card.type === "check") {
              Toastify({
                text: `You answered 'no' on the previous check ${leechCount} times in a row - it might be a leech. \n Is it a good question? Is it the difficulty appropriate?`,
                duration: 19000,
                newWindow: true,
                close: true,
                gravity: "bottom", // `top` or `bottom`
                position: "center", // `left`, `center` or `right`
                stopOnFocus: true, // Prevents dismissing of toast on hover
                style: {
                  background: "var(--primary-500)",
                },
              }).showToast();
            } else if (
              card.type === "readingList" ||
              card.type === "articleList"
            ) {
              Toastify({
                text: `You delayed making progress with the previous card ${leechCount} times in a row - it might be a leech. \n Do you have the book ready? Do you really want to read it?`,
                duration: 19000,
                newWindow: true,
                close: true,
                gravity: "bottom", // `top` or `bottom`
                position: "center", // `left`, `center` or `right`
                stopOnFocus: true, // Prevents dismissing of toast on hover
                style: {
                  background: "var(--primary-500)",
                },
              }).showToast();
            }
          }
        }

        let card = state.currentQueueCard;
        // handling different types of cards
        if (card.type === "standard") {
          //  see again after 1 day

          card.nextShown = +new Date() / 1000 + 60 * 60 * 24;
        }
        if (card.type === "todo") {
          if (vote === 2) {
            checkIsLeech(card, vote);
          }
          if (vote === 3) {
            // see again in 10 minutes
            card.nextShown = +new Date() / 1000 + 600;
          } else if (vote === 2) {
            // see again in one day
            card.nextShown = +new Date() / 1000 + 16 * 60 * 60;
          } else {
            // delete todo, either because we give up or because its done
            this.dispatch("deleteCard", card);
            wasDeleted = true;
          }
        }

        if (card.type === "articleList") {
          if (vote === 2) {
            checkIsLeech(card, vote);
          }
          if (vote === 3) {
            // see again in 10 minutes
            card.nextShown = +new Date() / 1000 + 600;
          } else if (vote === 2 || vote === 4) {
            // see again in one day
            card.nextShown = +new Date() / 1000 + 16 * 60 * 60;
          } else if (vote === 5) {
            // Done reading: convert to standard, and see again in a week
            card.nextShown = +new Date() / 1000 + 16 * 60 * 60 * 7;
            card.interval = 1;
            card.type = "standard";
          }
          else if (vote === 1) {
            // delete todo, either because we give up or because its done
            this.dispatch("deleteCard", card);
            wasDeleted = true;
          }
        }

        if (card.type === "learn") {
          // if vote is 0, that means a new learn card was just activated
          // it is now in learning mode and may be learned in a few minutes immediately
          if (vote === 0) {
            card.nextShown = +new Date() / 1000 + 60 * 3;
          } else {
            // otherwise, it gets the good old srs calculation treatment
            // but first, check if its a leech if vote is "Blackout"
            if (vote === 1) {
              checkIsLeech(card, vote);
            }
            let srs = {
              interval: card.interval,
              repetition: card.repetition,
              efactor: card.ease,
            };

            srs = supermemo(srs, vote);

            card.interval = srs.interval;
            card.repetition = srs.repetition;
            card.ease = srs.efactor;

            card.nextShown = +new Date() / 1000 + 16 * 60 * 60 * card.interval;
          }
        }

        if (card.type === "check") {
          if (vote === 1) {
            checkIsLeech(card, vote);
          }
          // see again in as much time as set
          if (card.unit === "days") {

            // if the interval is n, set nextShow to n-1 days and 16 hours
            card.nextShown = +new Date() / 1000 + 24 * 60 * 60 * (card.interval - 1) + 16 * 60 * 60;
          } else if (card.unit === "hours") {

            // see again in n hours
            const timePass = 60 * 60 * card.interval;
            card.nextShown = +new Date() / 1000 + timePass;
          }
        }

        if (card.type === "habit") {
          if (vote === 1 || vote === 2) {
            checkIsLeech(card, vote);
          }

          if (vote === 1) {
            // see again in a day
            card.nextShown = +new Date() / 1000 + 16 * 60 * 60;
          }
          if (vote === 2) {
            // see again in 10 minutes
            card.nextShown = +new Date() / 1000 + 600;
          }
          if (vote === 5) {
            if (card.unit === "days") {

              // see again in n days
              card.nextShown = +new Date() / 1000 + 24 * 60 * 60 * (card.interval - 1) + 16 * 60 * 60;

            } else if (card.unit === "hours") {

              // see again in n hours
              const timePass = 60 * 60 * card.interval;
              card.nextShown = +new Date() / 1000 + timePass;
            }
          }
        }

        if (card.type === "readingList") {
          if (vote === 2 || vote === 3) {
            checkIsLeech(card, vote);
          }

          card.interval = 0;
          if (vote === 1) {

            this.dispatch("deleteCard", card);
            wasDeleted = true;
          }
          if (vote === 2 || vote === 4) {

            card.nextShown = +new Date() / 1000 + 16 * 60 * 60;
            card.startedReading = true;
          }
          if (vote === 3) {
            // see again in 10 minutes
            card.nextShown = +new Date() / 1000 + 600;
            card.startedReading = true;
          }
          if (vote === 5) {

            // Done reading: convert to standard, and see again in a week
            card.nextShown = +new Date() / 1000 + 16 * 60 * 60 * 7;
            card.interval = 1;
            card.type = "standard";
          }


        }

        if (!wasDeleted) {

          card.nextShown = Math.floor(card.nextShown);
          card.occurrences = card.occurrences + 1;
          this.dispatch("updateCard", card);
        }

        state.showBack = false;
      } catch (error) {


      }
    },

    // SCORES

    async addToScores({ commit, state }, data) {
      const scoreValue = data.score;
      const inputValue = data.vote;
      const skipNote = data.skipNote;

      try {
        // get name of current router view
        const currentRoute = router.currentRoute._value.name;
        // saving the type and id of currentQueueCardonly makes sense if we are actually in the queue
        let cardType = "";
        let cardId = "";
        if (currentRoute === "Queue") {
          cardType = state.currentQueueCard.type || "editPoints";
          cardId = state.currentQueueCard.id || "---";
        }

        const score = {
          user_id: supabase.auth.currentUser.id,
          id: uuidv4(),
          value: scoreValue,
          datetime: new Date().toISOString().toLocaleString(),
          type: cardType,
          card_id: cardId,
          input_type: inputValue,
          skip_note: skipNote,
        };
        let { error } = await supabase
          .from("scores")
          .insert(score, { returning: "minimal" });


        if (error) throw error;
        const newScore = state.profile.score + scoreValue;

        const { err } = await supabase
          .from("profiles")
          .update({
            score: newScore,
          })
          .match({ user_id: supabase.auth.currentUser.id });
        if (err) throw err;

        commit("addToScores", score);
      } catch (error) {
        ErrorToast("Error saving score.", error)

      }
    },

    async getUserScore({ commit, state }) {
      try {
        let nDaysAgo = new Date();
        nDaysAgo = nDaysAgo.setDate(nDaysAgo.getDate() - 8);
        nDaysAgo = new Date(nDaysAgo).toISOString();

        let { error, data } = await supabase
          .from("scores")
          .select()
          .gt("datetime", nDaysAgo)
          .order("datetime", { ascending: false })
          .match({ user_id: supabase.auth.currentUser.id });
        if (error) throw error;

        commit("setScores", data);
      } catch (error) {
        ErrorToast("Error getting scores.", error)

      }
    },

    async getUserProfile({ commit, state }) {
      try {
        const { error, data } = await supabase
          .from("profiles")
          .select()
          .match({ user_id: supabase.auth.currentUser.id });
        if (error) throw error;

        // if profile does not exist, make a new one for the user
        if (data.length === 0) {
          const profile = {
            user_id: supabase.auth.currentUser.id,
            id: uuidv4(),
          };
          const { error } = await supabase
            .from("profiles")
            .insert(profile, { returning: "minimal" });
          if (error) throw error;

          commit("setProfile", profile);
          commit("setScore", 0);
        } else {

          commit("setProfile", data[0]);
          commit("setScore", data[0].score);
        }
      } catch (error) {
        console.warn(
          "error getting user profile",
          error.error_description || error.message || error
        );
      }
    },
    async setIntroFinished({ commit, state }) {
      try {
        const { error } = await supabase
          .from("profiles")
          .update({
            has_intro: true,
          })
          .match({ user_id: supabase.auth.currentUser.id });
        // commit the state profile with everything the same just has_intro: true
        commit("setProfile", { ...state.profile, has_intro: true });

        if (error) throw error;
      } catch (error) {
        ErrorToast("Error setting intro to finished.", error)
      }
    },
    async getStatistics({ commit, state }) {
      try {
        // get the number of cards of the user
        const { error, count } = await supabase
          .from("cards")
          .select("*", { count: "exact", head: true })
          .match({ user_id: supabase.auth.currentUser.id });
        if (error) throw error;
        state.statistics["cardCount"] = count;

        // get active packs
        let { error: error3, data: data3 } = await supabase
          .from("packs")
          .select("id, name")
          .match({ user_id: supabase.auth.currentUser.id, isDisabled: false });
        if (error3) throw error3;

        // generate a collectionsFilter array for querying only valid cards out of these collections
        const collection_ids = data3.map((collection) => collection.id);
        const collectionsFilter = '("' + collection_ids.join('","') + '")';

        // get the number of cards in active collections
        let { error: error4, count: count4 } = await supabase
          .from("cards")
          .select("*", { count: "exact", head: true })
          .filter("pack_id", "in", collectionsFilter)
          .match({
            user_id: supabase.auth.currentUser.id,
          });

        if (error4) throw error4;
        state.statistics["cardCountActive"] = count4;

        // get the number of cards of the user that are due
        const { error: error2, count: count2 } = await supabase
          .from("cards")
          .select("*", { count: "exact", head: true })
          // ignore cards of type 'other' as well as 'readingList'
          .neq("type", "standard")
          .neq("type", "readingList")
          .neq("type", "project")
          .filter("pack_id", "in", collectionsFilter)
          .lt("nextShown", +new Date() / 1000)
          .match({ user_id: supabase.auth.currentUser.id });
        if (error2) throw error2;
        state.statistics["cardCountDue"] = count2;

        // if there are less than 50 cards due, get them and log them in the console
        if (count2 < 50) {
          let { error: error99, data: data99 } = await supabase
            .from("cards")
            .select("*")
            .neq("type", "standard")
            .neq("type", "readingList")
            .neq("type", "project")
            .filter("pack_id", "in", collectionsFilter)
            .lt("nextShown", +new Date() / 1000)
            .match({ user_id: supabase.auth.currentUser.id });
          if (error99) throw error99;

        }

        // get the number of learning cards that are due
        const { error: error5, count: count5 } = await supabase
          .from("cards")
          .select("*", { count: "exact", head: true })
          .filter("pack_id", "in", collectionsFilter)
          .eq("type", "learn")
          .lt("nextShown", +new Date() / 1000)
          .match({ user_id: supabase.auth.currentUser.id });
        if (error5) throw error5;
        state.statistics["cardCountLearning"] = count5;

        // get the number of cards which have a nextShown of 0 or 1
        const { error: error6, count: count6 } = await supabase
          .from("cards")
          .select("*", { count: "exact", head: true })
          .filter("pack_id", "in", collectionsFilter)
          .eq("occurrences", 0)
          .match({ user_id: supabase.auth.currentUser.id });
        if (error6) throw error6;
        state.statistics["newCards"] = count6;
      } catch (error) {
        ErrorToast("Error getting statistics.", error)
      }
    },
  },
  getters: {
    getCurrentCollection: (state) => {

      const collection = state.collections.find(
        (collection) => collection.id === state.currentPackId
      );

      return collection;
    },
    getCurrentEditCard: (state) => {
      // find the current collection
      const currentCollection = state.collections.find(
        (collection) => collection.id === state.currentPackId
      );
      // if currentEditCard Id does not exist, set it to first card in current collection
      // except if current collection is empty, then just set it to null
      if (state.currentEditCardId === null) {
        if (state.editCards.length > 0) {
          state.currentEditCardId =
            state.editCards[state.editCards.length - 1].id;
        } else {
          state.currentEditCardId = null;
        }
      }

      // find the current card
      const currentCard = state.editCards.find(
        (card) => card.id === state.currentEditCardId
      );

      // return the current card
      return currentCard;
    },
  },
  modules: {},
});
